import request from '@/config/axios'

export interface AreaAgentSettleBuildReqVO {
  startTime: string
  endTime: string
  remark?: string
}

export interface AreaAgentSettleBillVO {
  id?: number
  no?: string
  status?: number
  startTime?: string
  endTime?: string
  goodsAmount?: number
  bonusAmount?: number
  orderCount?: number
  partnerCount?: number
  confirmTime?: string
  settleTime?: string
  cancelTime?: string
  remark?: string
  createTime?: string
  orders?: {
    id?: number
    orderId?: number
    matchLeafAreaId?: number
    provinceId?: number
    cityId?: number
    districtId?: number
    pickUpStoreId?: number
    goodsDiscounted?: number
    lockStatus?: number
  }[]
  items?: {
    id?: number
    orderId?: number
    userId?: number
    nickname?: string
    agentType?: number
    areaId?: number
    levelId?: number
    levelName?: string
    bonusRate?: number
    systemAmount?: number
    adjustAmount?: number
    adjustReason?: string
  }[]
}

export interface AreaAgentSettlePreviewVO {
  goodsAmount?: number
  bonusAmount?: number
  orderCount?: number
  partnerCount?: number
  orders?: any[]
  layers?: any[]
}

export const previewAreaAgentSettle = async (data: AreaAgentSettleBuildReqVO) => {
  return await request.post<AreaAgentSettlePreviewVO>({
    url: '/trade/area-agent/settle/preview',
    data
  })
}

export const createAreaAgentSettle = async (data: AreaAgentSettleBuildReqVO) => {
  return await request.post({ url: '/trade/area-agent/settle/create', data })
}

export const adjustAreaAgentSettle = async (data: {
  billId: number
  itemId: number
  adjustAmount: number
  adjustReason?: string
}) => {
  return await request.put({ url: '/trade/area-agent/settle/adjust', data })
}

export const confirmAreaAgentSettle = async (id: number) => {
  return await request.put({ url: '/trade/area-agent/settle/confirm', params: { id } })
}

export const cancelAreaAgentSettle = async (id: number) => {
  return await request.put({ url: '/trade/area-agent/settle/cancel', params: { id } })
}

export const settleAreaAgentSettle = async (id: number) => {
  return await request.put({ url: '/trade/area-agent/settle/settle', params: { id } })
}

export const getAreaAgentSettle = async (id: number) => {
  return await request.get<AreaAgentSettleBillVO>({
    url: '/trade/area-agent/settle/get',
    params: { id }
  })
}

export const getAreaAgentSettlePage = async (params: any) => {
  return await request.get({ url: '/trade/area-agent/settle/page', params })
}
